<template>
  <div>
    <v-card-text class="dialog-text pa-0 mt-8">
      <v-row class="align-center">
        <v-col cols="12" v-observe-visibility="visibilityChanged">
          <LazyYoutube
            :src="videoUrl"
            ref="youtubeVideo"
            maxWidth="960px"
            aspectRatio="21:9"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import Vue from "vue";
import { LazyYoutube } from "vue-lazytube";
import { ObserveVisibility } from "vue-observe-visibility";
Vue.directive("observe-visibility", ObserveVisibility);
export default {
  name: "Video",
  components: {
    LazyYoutube
  },
  props: {
    videoUrl: String
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.$refs["youtubeVideo"]["playVideo"]();
      } else {
        this.$refs["youtubeVideo"]["pauseVideo"]();
      }
    }
  }
};
</script>
